/**
 *
 * ActionMenuButton
 *
 */

import styled from 'styled-components';

import { COLORS } from 'utils/constants';

const ActionMenuButton = styled.button`
    display: block;
    padding: .75rem;
    padding-right: 3rem;
    background: transparent;
    border: 0;
    color: ${COLORS.siteDarkGrey};
    font-family: 'avenir', sans-serif;
    font-size: .875rem;
    white-space: nowrap;
    cursor: default;
    &.active {
        font-weight: bold;
    }
    &:hover,
    &:focus,
    &:active {
        border: 0;
        background: transparent;
        color: ${COLORS.siteDarkGrey};
        outline: 0;
    }
`;

export default ActionMenuButton;



// WEBPACK FOOTER //
// ./src/components/ActionMenuButton/index.js